<template>
  <div>
    <form action="/">
      <div class="form-wrap">
        <van-search v-model="searchValue" show-action background="#0a315d" clearable left-icon="#" placeholder="请输入搜索关键字" @search="queryList">
          <template #action>
            <div style="background-color: #0a315d">
              <van-icon name="search" size="20" class="icon-style" color="#fff" @click="queryList()" />
              <van-icon style="margin-left: 10px" size="20" name="filter-o" color="#fff" @click="handleFilter()" />
            </div>
          </template>
        </van-search>
      </div>
    </form>
  </div>
</template>
<script>
import { Search, Icon } from 'vant'
export default {
  props: {
    value: String,
    placeholder: String
  },
  watch: {
    value(value) {
      this.searchValue = value
    },
    placeholder(value) {
      this.placeholderValue = value
    }
  },
  data() {
    return {
      searchValue: '',
      placeholderValue: this.placeholder
    }
  },
  name: 'SearchComponent',
  components: {
    [Search.name]: Search,
    [Icon.name]: Icon
  },
  mounted() {
    if (sessionStorage.getItem('paymentSearch')) {
      this.searchValue = JSON.parse(sessionStorage.getItem('paymentQuery')).teamName || ''
    } else if (sessionStorage.getItem('contractSearch')) {
      this.searchValue = JSON.parse(sessionStorage.getItem('contractQuery')).contractName || ''
    } else if (sessionStorage.getItem('advancesSearch')) {
      this.searchValue = JSON.parse(sessionStorage.getItem('advancesQuery')).contractName || ''
    } else {
      sessionStorage.removeItem('paymentQuery')
      sessionStorage.removeItem('contractQuery')
      sessionStorage.removeItem('advancesQuery')
    }
  },
  methods: {
    queryList() {
      // if (this.searchValue === "") {
      //   return false
      // }else{
      //   this.$emit("handleQueryData", this.searchValue);
      // }
      this.$emit('handleQueryData', this.searchValue)
    },
    // 点击过滤按钮
    handleFilter() {
      console.log('handleFilter')
      this.$emit('handleFilterData')
    }
    // 聚焦

  }
}
</script>
<style lang="less">
.form-wrap {
  width: 100%;
  z-index: 1000;
  overflow: hidden;
  position: fixed;
  height: 100px;
  .icon-style {
    background-color: #0a315d;
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
  }
}
.van-search__action {
  line-height: 1;
}
.van-search__action:active {
  background-color: #0a315d;
}
</style>
